import _ from 'lodash'

import { defaultTheme } from './theme'
import { BriqTheme } from './theme'

export function createBriqTheme(override?: Partial<BriqTheme>): BriqTheme {
  return _.merge(_.cloneDeep(defaultTheme), override || {})
}
